export default __webpack_public_path__ + "static/TARBOT-CAD-7e6a952d2bf6ca96bd881958d5a84d42.png";